import React, { useEffect } from 'react';
import { Provider, connect } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import * as R from 'ramda';
import { BrowserRouter as Router } from 'react-router-dom';
import { useLDClient } from 'launchdarkly-react-client-sdk';

import { createPosStore } from './state';
import { getOrderRequest } from './pages/cart/Cart.state';

import AllRoutes from './components/routes';
import {
  getAccessToken,
  getRefreshToken,
  getDecodedAccessToken,
} from './utils/state';
const App = ({
  clientMetadata,
  theme,
  isLoggedIn,
  hasTerminalSession,
  getOrder,
  order,
  terminalSession,
}) => {
  const ldClient = useLDClient();

  useEffect(() => {
    if (!order.order_id && hasTerminalSession && isLoggedIn) {
      getOrder();
    }
  }, [isLoggedIn, hasTerminalSession]);

  useEffect(() => {
    const { email, client_slug, uid } = getDecodedAccessToken();
    const userContext =
      terminalSession && uid
        ? {
            user: {
              kind: 'user',
              key: `user-${uid}`,
              _meta: {
                privateAttributes: ['email'],
              },
              email: email,
              client: client_slug,
              terminal: terminalSession?.terminal,
              location: terminalSession?.location,
            },
          }
        : {};
    const currentContext = ldClient.getContext();
    const context = { ...currentContext, ...userContext };
    ldClient.identify(context);
  }, [terminalSession]);

  return (
    <div data-testid="app" className="app">
      <ThemeProvider
        theme={{
          name: 'default',
          values: theme.data,
          metadata: clientMetadata,
        }}
      >
        <Router>
          <AllRoutes
            isLoggedIn={isLoggedIn}
            hasTerminalSession={hasTerminalSession}
          />
        </Router>
      </ThemeProvider>
    </div>
  );
};

const mapStateToProps = (state) => ({
  clientMetadata: R.path(['global', 'clientMetadata'], state),
  theme: R.path(['global', 'theme'], state),
  isLoggedIn: Boolean(getRefreshToken()) && Boolean(getAccessToken()),
  hasTerminalSession: Boolean(state.terminalLogin.terminalSession),
  order: R.pathOr({}, ['cart', 'order'], state),
  terminalSession: state.terminalLogin.terminalSession,
});
const mapDispatchToProps = {
  getOrder: getOrderRequest,
};
const ConnectedApp = connect(mapStateToProps, mapDispatchToProps)(App);
export const ConfigContext = React.createContext({});

export default ({ configData }) => (
  <ConfigContext.Provider config={configData} value={null}>
    <Provider store={createPosStore(configData)}>
      <ConnectedApp />
    </Provider>
  </ConfigContext.Provider>
);
